import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=85c58004&scoped=true&"
import script from "./Query.vue?vue&type=script&lang=js&"
export * from "./Query.vue?vue&type=script&lang=js&"
import style0 from "./Query.vue?vue&type=style&index=0&id=85c58004&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c58004",
  null
  
)

export default component.exports